"use client"

import { Plane } from "lucide-react"
import { DynamicIcon, type IconName } from "lucide-react/dynamic"

interface CategoryIconProps {
  name: string | null
  className?: string
}

export function CategoryIcon({ name, className }: CategoryIconProps) {
  const resolved = (name ?? "plane") as IconName
  return (
    <DynamicIcon
      name={resolved}
      className={className}
      fallback={() => <Plane className={className} />}
    />
  )
}
